<template>
  <div class="card">
    <header class="card-header">
      <p class="card-header-title">Novo pedido de compra</p>
    </header>
    <div class="card-content" v-bind:class="{ disable: hasPendingOrder }">
      <!-- <div class="form-labels">
        <p style="line-height: 1em">Valor</p>

        <p style="line-height: 1em">Form de pagamento</p>
      </div> -->
      <form @submit.prevent="validateBeforeSubmit" id="quick-order">
        <div class="group-form">
          <b-field
            expanded
            size="is-medium"
            :type="{ 'is-danger': errors.has('paymentMethod') }"
            label="Forma de pagamento"
          >
            <b-select
              name="paymentMethod"
              expanded
              v-model="data.paymentMethod"
              v-validate="'required'"
            >
              <option
                v-for="method in paymentMethods"
                :value="method.value"
                :key="method.value"
              >
                {{ method.label }}
              </option>
            </b-select>
          </b-field>

          <b-field
            label="Valor"
            expanded
            :type="{ 'is-danger': errors.has('total') }"
            :message="errors.first('total')"
            size="is-merdium"
            v-if="!!data.paymentMethod"
          >
            <b-input
              name="total"
              v-model="data.total"
              v-validate="'required'"
              @input="currencyMask"
            />
          </b-field>
        </div>

        <div class="group-form">
          <div class="custom-datepicker">
            <b-datepicker
              v-model="dueDate"
              placeholder="Escolha a data de vencimento"
              :horizontal-time-picker="false"
              :min-date="minDatetime"
              :max-date="maxDatetime"
              :locale="'pt-BR'"
              :day-names="['D', 'S', 'T', 'Q', 'Q', 'S', 'S']"
              :month-names="[
                'Janeiro',
                'Fevereiro',
                'Março',
                'Abril',
                'Maio',
                'Junho',
                'Julho',
                'Agosto',
                'Setembro',
                'Outubro',
                'Novembro',
                'Dezembro',
              ]"
              v-if="data.paymentMethod === 'bankslip'"
            >
            </b-datepicker>
          </div>

          <div class="control">
            <button
              class="button is-primary"
              type="submit"
              @click.prevent="validateAndSubmit"
              :disabled="hasPendingOrder || isLoading"
            >
              Enviar
            </button>
          </div>
        </div>
      </form>
    </div>
    <b-notification
      type="is-warning"
      aria-close-label="Close notification"
      v-if="hasPendingOrder"
      :closable="false"
    >
      Você tem um
      <router-link to="/compras" class="is-text">pedido pendente</router-link>.
    </b-notification>
  </div>
</template>

<script>
import orders from "../../services/orders";
import { format } from "date-fns";

export default {
  data() {
    const min = new Date();
    const max = new Date();

    min.setDate(min.getDate() - 1);

    max.setDate(max.getDate() + 30);

    return {
      title: "Comprar créditos",
      actions: [
        {
          label: "Voltar",
          route: "/compras",
        },
      ],
      paymentMethods: [
        {
          value: "bankslip",
          label: "Boleto",
        },
        {
          value: "pix",
          label: "Pix",
        },
        {
          value: "",
          label: "Selecione um método",
        },
      ],
      data: {
        paymentMethod: "",
      },
      isLoading: false,
      amountPresets: [],
      products: {},
      hasPendingOrder: false,
      minDatetime: min,
      maxDatetime: max,
      dueDate: new Date(),
    };
  },
  async mounted() {
    const isPending = await this.checkIfHasPendingOrder();

    if (!isPending) {
      orders.getProducts().then((products) => {
        this.products = products;

        this.amountPresets = Object.keys(products).map((a) => ({
          value: a,
          title: products[a],
        }));
      });
    }

    this.hasPendingOrder = isPending;
  },
  methods: {
    currencyMask(value) {
      let rawValue = value.replace(".", "").replace(",", "").replace(/\D/g, "");

      if (rawValue.length === 0) {
        rawValue = "0,00";
      }

      const formattedValue = new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
      }).format(parseFloat(rawValue) / 100);

      this.data.total = `R$ ${formattedValue.replace("BLR", "").trim()}`;
    },
    async checkIfHasPendingOrder() {
      const orderList = await orders.all();
      const pendingOrder = (orderList || [])
        .slice()
        .reverse()
        .find((order) => order.status === "PENDING");

      try {
        return !!pendingOrder;
      } catch {
        return false;
      }
    },
    getRawData() {
      const rawData = {
        total: this.data.total.replace("R$ ", ""),
        paymentMethod: this.data.paymentMethod,
      };

      if (this.data.paymentMethod === "bankslip") {
        rawData.dueDate = format(this.dueDate, "yyyy-MM-dd");
      }

      rawData.total = parseFloat(
        rawData.total
          .replace("R$", "")
          .replace(/\s/g, "")
          .replace(".", "")
          .replace(",", ".")
      );

      return rawData;
    },
    validateAndSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.save(this.getRawData());
          return;
        }
        this.$buefy.toast.open({
          message: "Verfique os campos marcados para continuar",
          type: "is-danger",
        });
      });
    },
    async save(rawData) {
      try {
        this.isLoading = true;

        this.$buefy.dialog.confirm({
          message: `Você confirma o pedido de <strong>${this.data.total}</strong> em créditos?`,
          onConfirm: async () => {
            const { total, paymentMethod, dueDate } = rawData;
            const newOrder = await orders.create(
              { total, dueDate },
              paymentMethod
            );

            localStorage.setItem("newOrder", newOrder.id);

            this.$router.push({
              name: "orders",
            });

            this.$buefy.toast.open({
              message: "Pedido de compra realizada com sucesso.",
              type: "is-success",
            });
            this.data.total = "";
          },
        });
      } catch (err) {
        console.error(err);
        this.$buefy.toast.open({
          message: "Erro ao enviar pedido.",
          type: "is-danger",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.group-form {
  display: flex;
  gap: 20px;

  > .field {
    width: 50%;
  }

  > .field:first-child:last-child {
    width: 100%;
    margin-bottom: 0.75rem;
  }
}

.form-labels {
  display: flex;

  > p {
    margin-bottom: 10px;
  }

  > p:first-child {
    width: calc(50% - 20px);
    margin-right: 20px;
  }

  > p:last-child {
    width: 50%;
  }
}

.card-content.disable {
  pointer-events: none;
  position: relative;
  opacity: 0.6;
  user-select: none;
}

.control {
  width: 100%;
}

.control .button {
  display: block;
  width: 100% !important;
}
</style>

<style>
#quick-order .select {
  width: 100% !important;
}

#quick-order .select select {
  width: 100% !important;
}

.custom-datepicker {
  width: 100%;
}
</style>
